import React from 'react';
import Stack from '@mui/material/Stack';
import Alert from '@mui/material/Alert';
import AlertTitle from '@mui/material/AlertTitle';
import { Link as LINK } from 'react-router-dom';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@material-ui/icons/Close';

const FloatingAlert = ({
  text,
  setAlert,
  matches,
  top,
  color,
}: {
  text: string;
  setAlert: any;
  matches: boolean;
  color: 'info' | 'error';
  top?: number;
}) => {
  return (
    <div
      style={{
        position: 'fixed',
        width: matches ? '70%' : 'clamp(300px, 50%, 500px)',
        top: (top ? top : 5) + '%',
        right: 5 + '%',
        zIndex: 3000,
        filter: 'drop-shadow(0 0 10px #00000033)',
        overflow: 'hidden',
      }}
    >
      <Stack sx={{ width: '100%' }} spacing={2}>
        <Alert
          severity={color}
          color={color}
          action={
            <IconButton
              aria-label="close"
              size="large"
              onClick={() => {
                setAlert(false);
              }}
              sx={{
                marginTop: '-10px',
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          }
        >
          {/* Using Link from react-router-dom as LINK as It dosen't reload the page and faster */}
          <AlertTitle sx={{ color: '#000' }}>Warning</AlertTitle>
          {text}
        </Alert>
      </Stack>
    </div>
  );
};

export default FloatingAlert;
